import { DataCatalogDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

export const useDataCatalogSelector = () => {
  const { company } = useCurrentSession()
  const companyId = company?.id

  const { data, loading, error } = useQuery(DataCatalogDocument, { variables: { companyId } })

  const datasources = data?.iris.factTablesConnection.edges.map((edge) => edge.node)

  return { data, loading, error, datasources }
}
